import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';
import { getRabbitColorFromKey } from 'constants/helper';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

const getGridLineChartDataAPI = ({ cohortToPass, employeeId }) => {
  const url = endpoints.performanceReview.newNav.gridLineGraphV1;
  const body = {
    reviewCycleId: null,
  };
  if (cohortToPass?.cohort?.id) {
    body.cohortId = cohortToPass.cohort.id;
  }
  if (employeeId) {
    body.employeeId = employeeId;
  }
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body,
  });
};

const getGridLineChartData = async ({ cohortToPass, employeeId }) => {
  try {
    const res = await getGridLineChartDataAPI({ cohortToPass, employeeId });
    if (!res.entity) {
      return { employeeReviewCycleData: [], gridDefinition: [] };
    }
    let arrayGridDefinition = Object.keys(res.entity.gridDefinition)
      .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
      .map((key) => res.entity.gridDefinition[key]);
    arrayGridDefinition = arrayGridDefinition.map((gridRow) =>
      gridRow.map(({ color, ...rest }) => ({
        ...rest,
        color: getRabbitColorFromKey(color),
      }))
    );

    const employeeReviewCycleDataProcessed = res.entity.employeeReviewCycleData.map(({ employee, dataSeries }) => ({
      employee: { ...employee, name: employee.displayName, imageUrl: employee.profilePhoto },
      dataSeries: dataSeries.map(({ reviewCycleId, reviewCycleName, ...other }) => ({
        ...other,
        reviewCycle: { id: reviewCycleId, name: reviewCycleName },
      })),
    }));

    return {
      employeeReviewCycleData: employeeReviewCycleDataProcessed,
      gridDefinition: arrayGridDefinition,
      apiData: res.entity,
    };
  } catch (err) {
    console.error('Error fetching grid line chart data : ', err);
  }
  return null;
};

const useGetGridChartData = ({ cohortToPass, employeeId }) =>
  useQuery([REACT_QUERY_KEYS.deerReviewsOverview.performanceGrid], () =>
    getGridLineChartData({ cohortToPass, employeeId })
  );

export { useGetGridChartData };
